export function isNotFalse<T>(value: false | T): value is T {
  return value !== false;
}

export function isNotNil<T>(value: T): value is NonNullable<T> {
  return value !== undefined && value !== null;
}

export function not<T>(fn: (arg: T) => boolean) {
  return (x: T) => !fn(x);
}
